var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M32,8 C18.7352188,8 8,18.734 8,32 C8,45.2645937 18.734,56 32,56 C45.2647812,56 56,45.266 56,32 C56,18.7354063 45.266,8 32,8 Z M34.4645937,41.5269688 C34.4645937,42.2852188 33.3589063,43.0432812 32.0004688,43.0432812 C30.5788438,43.0432812 29.5680313,42.2852187 29.5680313,41.5269688 L29.5680313,29.4906875 C29.5680313,28.6061562 30.5789375,28.0057812 32.0004688,28.0057812 C33.3589063,28.0057812 34.4645937,28.6061562 34.4645937,29.4906875 L34.4645937,41.5269688 Z M32.0005625,25.099625 C30.5473437,25.099625 29.4101562,24.0255313 29.4101562,22.8249688 C29.4101562,21.6245 30.5474375,20.582 32.0005625,20.582 C33.4221875,20.582 34.5595625,21.6245 34.5595625,22.8249688 C34.5595625,24.0255313 33.4220938,25.099625 32.0005625,25.099625 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.ebfc4e24f645a407255986c1c1460aec.svg";
export { ForwardRef as ReactComponent };